import PropTypes from "prop-types"
import Spinner from "components/spinner"

export default function Refresh({ hasData, isRefreshing, lastRefresh, customButton }) {
  return <div className="refresh">
    as of&nbsp;
    {lastRefresh}
    {!hasData && <div className="no-data">no data has been provided for today</div>}
    {/* We want to reserve the space the spinner will take up so that the content next to it doesn't jump around */}
    <div className="spinner-wrapper">
      {!customButton && isRefreshing && <Spinner />}
    </div>
    {customButton}
  </div>
}

Refresh.propTypes = {
  hasData: PropTypes.bool,
  isRefreshing: PropTypes.bool,
  lastRefresh: PropTypes.string,
  className: PropTypes.string,
  customButton: PropTypes.node,
}
